<div class="gamejr-container">
  <div class="gamejr-head">
    <div>
      <h4>{{ heading }}</h4>
      @if (destination && !isEdit) {
        <p class="gamejr-dest">
          <svg viewBox="0 0 24 24" width="14" height="14" fill="none" aria-hidden="true">
            <path d="M12 21s-6-5.3-6-10a6 6 0 0 1 12 0c0 4.7-6 10-6 10Z" stroke="currentColor" stroke-width="2" />
            <circle cx="12" cy="11" r="2.2" stroke="currentColor" stroke-width="2" />
          </svg>
          {{ destination }}
        </p>
      }
    </div>
    <button type="button" class="gamejr-close" aria-label="Cancel" (click)="closeForm()">
      <svg viewBox="0 0 24 24" width="18" height="18" fill="none" aria-hidden="true">
        <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
      </svg>
    </button>
  </div>

  <form [formGroup]="playerStoryForm" (ngSubmit)="handleSubmit()">
    <input type="text" class="gamejr-title" formControlName="title" #titleInput maxlength="100"
      placeholder="Title" aria-label="Title" />
    @if (playerStoryForm.get('title').touched && playerStoryForm.get('title').hasError('required')) {
      <div class="error-message">Give this entry a title.</div>
    }

    <textarea class="gamejr-entry" formControlName="details" (keydown)="onEntryKeydown($event)"
      placeholder="What happened? (optional)" aria-label="What happened (optional)"></textarea>

    @if (cityName && !isEdit) {
      <label class="gamejr-check">
        <input type="checkbox" [checked]="enterCity" (change)="enterCity = !enterCity" />
        <span>Enter <strong>{{ cityName }}</strong> after this move</span>
      </label>
    }

    <div class="gamejr-actions">
      <button type="button" class="gamejr-btn gamejr-btn--ghost" (click)="closeForm()">Cancel</button>
      <button type="submit" class="gamejr-btn gamejr-btn--primary" title="Ctrl + Enter">Save</button>
    </div>
  </form>
</div>
